import { useEffect } from 'react';
import { useAppDispatch, useAuthToken, useCookies } from '@shared/hooks';
import { getNotificationsList } from 'library/redux/notifications';

export const useLoadNotifications = () => {
  const dispatch = useAppDispatch();
  const { getCookie } = useCookies();
  const token = getCookie('token');
  const { token: authToken } = useAuthToken();
  useEffect(() => {
    token && dispatch(getNotificationsList());
  }, [dispatch, token]);

  useEffect(() => {
    const idInterval = setInterval(() => {
      token && dispatch(getNotificationsList());
    }, 60000);
    return () => {
      clearInterval(idInterval);
    };
  }, [dispatch, token, authToken]);
};

export default useLoadNotifications;
